import { useEffect, useState } from 'react'
import "../../style/common/cropper.scss"
// import Jimp from 'jimp';

export default function Cropper({ url = "", coordinates = [], id = 0, className, onCropperRender }) {

    const [ imageUrl, setImageUrl ] = useState(undefined);

    useEffect(() => {
        getCroppedImage()
    }, [ url, id ])

    const getCroppedImage = () => {
        const image = new Image();

        image.src = url
        // image.src = `data:image/jpg;base64,${url}`;
        image.setAttribute("crossOrigin", 'anonymous')
        image.onload = function () {
            let naturalWidth = this.width;
            let naturalHeight = this.height;

            const x = coordinates[ 0 ],
                y = coordinates[ 1 ],
                width = coordinates[ 2 ] - coordinates[ 0 ],
                height = coordinates[ 3 ] - coordinates[ 1 ];
            const crop = { x: parseInt(x.toFixed()), y: parseInt(y.toFixed()), width: parseInt(width.toFixed()), height: parseInt(height.toFixed()) };

            const imageCanvas = document.createElement("canvas");
            const scaleX = naturalWidth / image.width;
            const scaleY = naturalHeight / image.height;
            imageCanvas.width = crop.width;
            imageCanvas.height = crop.height;
            const imgCx = imageCanvas.getContext("2d");
            imgCx.drawImage(
                image,
                crop.x * scaleX,
                crop.y * scaleY,
                crop.width * scaleX,
                crop.height * scaleY,
                0,
                0,
                crop.width,
                crop.height
            );
            return new Promise((resolve, reject) => {
                imageCanvas.toBlob((blob) => {
                    if (!blob) {
                        reject(new Error("the image canvas is empty"));
                        return;
                    }
                    blob.name = "fileName";
                    let imageURL;
                    window.URL.revokeObjectURL(imageURL);
                    imageURL = window.URL.createObjectURL(blob);
                    resolve(imageURL);
                    setImageUrl(blob.toString());
                    var image = document.getElementById(`myImg-${id}`);
                    if(image){
                        image.src = imageURL.toString()
                    }
                    onCropperRender && onCropperRender()
                }, "image1/jpeg");
            });

            // return new Promise((resolve, reject) => {
            //     // imageCanvas.toBlob((blob) => {
            //         // if (!blob) {
            //         //     reject(new Error("the image canvas is empty"));
            //         //     return;
            //         // }
            //         // blob.name = "fileName";
            //         // let imageURL;
            //         // window.URL.revokeObjectURL(imageURL);
            //         // imageURL = window.URL.createObjectURL(blob);
            //         resolve(url);
            //         setImageUrl(url);
            //         var image = document.getElementById(`myImg-${id}`);
            //         if(image){
            //             image.src = url
            //         }
            //         onCropperRender && onCropperRender()
            //     // }, "image1/jpeg");
            // });

            
        }
    }

    return (
        <img className={`cropped-image ${className}`} id={`myImg-${id}`} src={imageUrl}></img>
    )
}
